import { GeoJsonLayer } from "@deck.gl/layers";
import chroma from "chroma-js";
import { Dispatch, useEffect, useState } from "react";
import pallas from "../../services/pallas";
import { OceanMask } from "./ocean-mask";

export type FishingSpot = { properties: { Sild: number, Makrell: number, Hyse: number, Sei: number, Uer: number, Lyr: number, Torsk: number, Breiflabb: number, Lange: number, Berggylt: number, Prob: number, [key: string]: number } }

const HEATMAP_COLOR_SCALE = chroma.scale(['008ae510', '008ae5']).classes(9).mode('lab');

export function useHeatmapGridLayer(daysAhead: number, species: string, setLoading: Dispatch<boolean>, highlightableAndPickable = true): GeoJsonLayer<FishingSpot> {

  const [heatmapData, setHeatmapData] = useState<any>();

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const d = await pallas.getHeatmap(daysAhead, species);
        setHeatmapData(d);
      } finally {
        setLoading(false);
      }
    })();
  }, [daysAhead, species, setLoading]);

  return new GeoJsonLayer({
    id: 'fishing_heatmap',
    data: heatmapData,
    pickable: highlightableAndPickable,
    autoHighlight: highlightableAndPickable,
    lineWidthMinPixels: 0.2,
    getFillColor: f => {
      const color = HEATMAP_COLOR_SCALE(parseFloat(f.properties[species].toString()));
      return [...color.rgb(), color.alpha() * 255];
    },
    getLineColor: [0, 0, 0, 0],
    highlightColor: [...chroma("008ae5").rgb(), 255],
    ...OceanMask.applyOceanMask()
  });
}